import * as R from 'ramda'
import { useSelector } from 'react-redux'
import { RootState } from '$setup/redux'
import { PendingEditUpload } from './types'

export const roomPendingEditUploadByIidView = R.memoizeWith(
  (roomId: string, iid: number) => `${roomId}-${iid}`,
  (roomId, iid) => (state: RootState) =>
    (state.main.pendingEditUploads as PendingEditUpload[]).find(
      pending => pending.roomId === roomId && pending.iid === iid,
    ),
)

export function useRoomPendingEditUploadByIid(roomId: string, iid: number) {
  return useSelector(roomPendingEditUploadByIidView(roomId, iid))
}
